import { render, staticRenderFns } from "./dualSyncMessage.vue?vue&type=template&id=f277f7b2&scoped=true"
import script from "./dualSyncMessage.vue?vue&type=script&lang=js"
export * from "./dualSyncMessage.vue?vue&type=script&lang=js"
import style0 from "./dualSyncMessage.vue?vue&type=style&index=0&id=f277f7b2&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f277f7b2",
  null
  
)

export default component.exports